import React from "react";
import Alert from "react-bootstrap/Alert";

const index = ({ variant, message }) => {
  return (
    <Alert key={variant} variant={variant} className="mt-1 text-center">
      {!message ? "Transacción no puede ser procesada" : message}
    </Alert>
  );
};

export default index;
